import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { pick } from '../utils';
/**
 * 参数注入
 * @description
 * 对应 Injectable 声明的变量，主要用于获取临时存储的变量；
 * 因为所有的流程都是唯一的，所以这里可以通过临时变量来存储；
 * 所有错误都必须重新再走一次流程，没有刷新或重试的机会；
 */

export var Inject = function Inject(variables) {
  return function (_target, _property, descriptor) {
    var noConfilt = descriptor.value;

    if (typeof noConfilt === 'function') {
      descriptor.value = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
          var injected, response, oauthToken;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  injected = pick.apply(void 0, [this.$$injectable].concat(_toConsumableArray(variables)));
                  _context.next = 3;
                  return noConfilt.call(this, _objectSpread(_objectSpread({}, injected), params));

                case 3:
                  response = _context.sent;
                  // 特殊处理oauthToken，永远不清除oauthToken
                  // 不应该在这个层级处理的
                  oauthToken = this.$$injectable.oauthToken;
                  this.$$injectable = {};
                  if (oauthToken) this.$$injectable.oauthToken = oauthToken;
                  return _context.abrupt("return", response);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
    }

    return descriptor;
  };
};